export const SETUP_CHECKLIST = [
  {
    id: 'brand-identity',
    title: 'Brand Identity',
    items: [
      { id: 'bi-1', title: 'Shop Name', description: "Finalise your shop name. Check it's available on Etsy, Shopify, and all social platforms simultaneously." },
      { id: 'bi-2', title: 'Logo Design', description: 'Create a primary logo. Tip: design for legibility at small sizes (favicon, profile picture).', specs: 'PNG/SVG, Min 500x500px' },
      { id: 'bi-3', title: 'Logo Variations', description: 'Create a horizontal version, a stacked version, and an icon-only version.' },
      { id: 'bi-4', title: 'Color Palette', description: 'Define 2–3 primary brand colors + 1–2 accent colors. Note HEX, RGB, and CMYK values. Tip: verify colors look consistent on screen and in print.' },
      { id: 'bi-5', title: 'Typography', description: 'Select a heading font and a body font. Download both for offline use.' },
      { id: 'bi-6', title: 'Brand Voice', description: "Write 2–3 sentences describing your shop's tone (e.g., playful, minimal, boho)." },
    ]
  },
  {
    id: 'etsy-setup',
    title: 'Etsy Shop Setup',
    items: [
      { id: 'et-1', title: 'Open Etsy Shop', description: 'Create account → Open a shop → Choose shop language, country, currency.' },
      { id: 'et-2', title: 'Shop Banner', description: 'Upload banner image.', specs: '3360×840px (desktop), 1200×300px (mobile safe)' },
      { id: 'et-3', title: 'Shop Icon / Logo', description: 'Upload shop profile image.', specs: '500×500px, JPG/PNG' },
      { id: 'et-4', title: 'Shop Title', description: 'Write a keyword-rich shop title.', specs: 'Max 55 characters' },
      { id: 'et-5', title: 'Shop Announcement', description: 'Write a welcome message. Include keywords naturally.' },
      { id: 'et-6', title: 'About Section', description: 'Write your shop story and add a shop owner photo.', specs: 'Min 100 words, Photo 400x400px' },
      { id: 'et-7', title: 'Shop Policies', description: 'Complete: Processing times, Returns & exchanges, FAQs, Custom orders policy.' },
      { id: 'et-8', title: 'Payment Setup', description: 'Connect Etsy Payments and/or PayPal.' },
      { id: 'et-9', title: 'Shipping Profiles', description: 'Set up at least one shipping profile with your main delivery regions.' },
      { id: 'et-10', title: 'Featured Listings', description: 'Plan which 4 listings will appear in your featured row.' },
    ]
  },
  {
    id: 'shopify-setup',
    title: 'Shopify Store Setup',
    items: [
      { id: 'sh-1', title: 'Create Shopify Account', description: 'Choose a plan. Set store name and URL.' },
      { id: 'sh-2', title: 'Theme Selection', description: 'Install a theme. Recommended free themes for POD: Dawn, Craft, Sense.' },
      { id: 'sh-3', title: 'Banner / Hero Image', description: 'Upload homepage hero banner.', specs: '2000×800px, JPG max 2MB' },
      { id: 'sh-4', title: 'Logo Upload', description: 'Upload logo to theme settings.', specs: 'Max 450px wide, SVG preferred' },
      { id: 'sh-5', title: 'Favicon', description: 'Upload favicon.', specs: '32×32px, ICO/PNG' },
      { id: 'sh-6', title: 'Color & Font Settings', description: 'Apply your brand colors and fonts in the theme editor.' },
      { id: 'sh-7', title: 'Navigation Menus', description: 'Set up header and footer menus.' },
      { id: 'sh-8', title: 'Pages', description: 'Create: About, Contact, FAQ, Shipping & Returns.' },
      { id: 'sh-9', title: 'Payment Gateway', description: 'Connect Shopify Payments, PayPal, or Stripe.' },
      { id: 'sh-10', title: 'POD Integration', description: 'Connect your POD supplier (e.g., Printful, Printify, Gelato) via App Store.' },
      { id: 'sh-11', title: 'Domain', description: 'Connect a custom domain or purchase one through Shopify.' },
      { id: 'sh-12', title: 'Test Order', description: 'Place a test order end-to-end before going live.' },
    ]
  },
  {
    id: 'social-facebook',
    title: 'Facebook Page',
    items: [
      { id: 'fb-1', title: 'Create Page', description: 'Create a Facebook Business Page (not personal profile).' },
      { id: 'fb-2', title: 'Profile Picture', description: 'Upload profile picture.', specs: '170×170px' },
      { id: 'fb-3', title: 'Cover Photo', description: 'Upload cover photo. Tip: keep key content in center 560px.', specs: '851×315px' },
      { id: 'fb-4', title: 'Page Bio', description: 'Write Page bio. Include shop URL.', specs: 'Max 255 characters' },
      { id: 'fb-5', title: 'Call-to-action', description: 'Add CTA button (e.g., "Shop Now") linking to your store.' },
    ]
  },
  {
    id: 'social-instagram',
    title: 'Instagram Business',
    items: [
      { id: 'ig-1', title: 'Create Account', description: 'Convert to or create an Instagram Business Account.' },
      { id: 'ig-2', title: 'Profile Picture', description: 'Use logo icon version.', specs: '320×320px' },
      { id: 'ig-3', title: 'Bio', description: 'Write bio. Include one link (use Linktree if needed).', specs: 'Max 150 characters' },
      { id: 'ig-4', title: 'Grid Planning', description: 'Plan a 9-post grid theme for launch.' },
      { id: 'ig-5', title: 'IG Shopping', description: 'Set up Instagram Shopping (link to Shopify/Etsy catalog if eligible).' },
    ]
  },
  {
    id: 'social-pinterest',
    title: 'Pinterest Business',
    items: [
      { id: 'pt-1', title: 'Create Account', description: 'Create or convert to a Pinterest Business Account.' },
      { id: 'pt-2', title: 'Profile Picture', description: 'Upload profile picture.', specs: '165×165px' },
      { id: 'pt-3', title: 'Board Setup', description: 'Create boards relevant to your niche (min 3 boards at launch).', specs: 'Covers: 800×450px' },
      { id: 'pt-4', title: 'Pin Templates', description: 'Create product pin templates. Tip: this is the highest-performing ratio.', specs: '1000×1500px (2:3)' },
      { id: 'pt-5', title: 'Rich Pins & Verification', description: 'Enable Rich Pins and verify your website with Pinterest.' },
    ]
  },
  {
    id: 'social-twitter',
    title: 'Twitter / X Profile',
    items: [
      { id: 'tw-1', title: 'Create Account', description: 'Create account with your brand handle.' },
      { id: 'tw-2', title: 'Profile Picture', description: 'Upload profile picture.', specs: '400×400px' },
      { id: 'tw-3', title: 'Header Image', description: 'Upload banner. Safe zone: center 1260×360px.', specs: '1500×500px' },
      { id: 'tw-4', title: 'Bio', description: 'Write bio. Include shop link.', specs: 'Max 160 characters' },
      { id: 'tw-5', title: 'Pinned Tweet', description: 'Pin a launch announcement tweet.' },
    ]
  }
];

export const RESEARCH_CHECKLIST = [
  { id: 'res-1', title: 'Niche Research', description: 'Identify your target niche. Use tools: Etsy search autocomplete, Pinterest Trends, Google Trends, EtsyHunt, Erank, Marmalead.' },
  { id: 'res-2', title: 'Trend Analysis', description: 'Search your niche keywords on Etsy. Note top-selling styles, colors, phrases. Look at "Bestseller" badges.' },
  { id: 'res-3', title: 'Competitor Analysis', description: 'Identify 5 top competitors. Note their: price points, number of listings, review counts, design styles, fulfillment suppliers.' },
  { id: 'res-4', title: 'Keyword Research', description: 'Build a keyword list. Target: 1–2 primary keywords + 5–8 long-tail keywords per product.' },
  { id: 'res-5', title: 'Product Selection', description: 'Choose product type. Check your POD supplier\'s catalog for availability, print quality reviews, and profit margins.' },
  { id: 'res-6', title: 'Pricing Research', description: 'Calculate cost: (POD base cost + shipping + fees) × margin. Typical POD margin target: 30–50%.' },
  { id: 'res-7', title: 'Validate Demand', description: 'Confirm search volume > 0 on Etsy. Check Pinterest for saves/repins on similar designs.' },
];

export const PRODUCTION_CHECKLIST = [
  { id: 'prod-1', title: 'Concept Sketch', description: 'Initial brainstorming, layout planning, and rough sketches.', specs: 'Idea Phase' },
  { id: 'prod-2', title: 'Final Artwork', description: 'Create high-resolution digital design with appropriate dimensions.', specs: '300 DPI, PNG' },
  { id: 'prod-3', title: 'Color Variations', description: 'Test design on different background colors (light/dark garments).', specs: 'Variations' },
  { id: 'prod-4', title: 'Mockup Generation', description: 'Apply design to high-quality lifestyle or studio mockups.', specs: 'Marketing' },
  { id: 'prod-5', title: 'SEO Optimized Copy', description: 'Write keyword-rich titles, descriptions, and 13 tags.', specs: 'Listing Prep' },
  { id: 'prod-6', title: 'Pricing & Weight', description: 'Finalize retail price and confirm shipping weight/profiles.', specs: 'Logistics' },
];

export const WORKFLOW_STAGES = ['Ideas', 'In Design', 'Mockup Review', 'Listed', 'Live'];

export const PRODUCT_TYPES = [
  'T-Shirt', 
  'Sweatshirt', 
  'Hoodie', 
  'Mug', 
  'Tote Bag', 
  'Poster', 
  'Phone Case', 
  'Sticker', 
  'Hat',
  'Notebook',
  'Other'
];

export const TIMETABLE = [
  { day: 'Monday', focus: 'Research & keyword planning' },
  { day: 'Tuesday', focus: 'Design creation (aim: 2–3 designs)' },
  { day: 'Wednesday', focus: 'Design creation continued + mockups' },
  { day: 'Thursday', focus: 'List products (write titles, descriptions, tags)' },
  { day: 'Friday', focus: 'Social media content creation + scheduling' },
  { day: 'Saturday', focus: "Analyze previous week's stats + competitor check" },
  { day: 'Sunday', focus: 'Rest or batch-create Pinterest pins' },
];